export default __webpack_public_path__ + "static/media/gallery_06.3b3563b7.jpg";